import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { IAssessmentQuestion } from "../models/assessmentQuestion";
import { IAssessment, INoctiAssessment, IWorksiteAssessment, IObservationalAssessment, IDisabilityBenefit } from "../models/assessment";

@Injectable({
  providedIn: "root"
})

export class AssessmentService {

  private baseUrl = "api/Assessment/";

  constructor(private http: HttpClient) { }

  getOnlyAssessment(): Observable<IAssessment[]> {
    return (this.http.get<IAssessment[]>(this.baseUrl + "GetOnlyAssessment"));
  }

  getCISAssessment(): Observable<string> {
    return (this.http.get<string>(this.baseUrl + "GetCISAssessment"));
  }

  getNoctiAssessments(): Observable<INoctiAssessment[]> {
    return (this.http.get<INoctiAssessment[]>(this.baseUrl + "GetNoctiAssessment"));
  }

  getSelfEvalAssessments(): Observable<IWorksiteAssessment[]> {
    return (this.http.get<IWorksiteAssessment[]>(this.baseUrl + "GetSelfEvalResults"));
  }

  getWorksiteAssessments(): Observable<IWorksiteAssessment[]> {
    return (this.http.get<IWorksiteAssessment[]>(this.baseUrl + "GetWorksiteAssessment"));
  }

  getObservationalAssessments(): Observable<IObservationalAssessment[]> {
    return (this.http.get<IObservationalAssessment[]>(this.baseUrl + "GetObservationalAssessment"));
  }

  getDisablityAssessments(): Observable<IDisabilityBenefit[]> {
    return (this.http.get<IDisabilityBenefit[]>(this.baseUrl + "GetDisabilityAssessment"));
  }

  getOnlyAssessmentByAssessmentId(assessmentId: number): Observable<IAssessment> {
    return (this.http.get<IAssessment>(this.baseUrl + "GetOnlyAssessmentByAssessmentId?assessmentId=" + assessmentId));
  }

  getQuestions(type: number): Observable<IAssessmentQuestion[]> {
    return this.http.get<IAssessmentQuestion[]>(this.baseUrl + "GetQuestions?type=" + type);
  }

  downloadCertification() {
    console.log("Certification link: " + this.baseUrl + "GetCertification");

    window.open(this.baseUrl + "GetCertification", '_blank', ''); 
  }

  getQuestionsByAssessmentId(assessmentId: number): Observable<IAssessmentQuestion[]> {
    return this.http.get<IAssessmentQuestion[]>(this.baseUrl + "GetQuestionsByAssessment?assessmentId=" + assessmentId);
  }

  saveAssessment(assessment: IAssessment): Observable<any> {
    return this.http.post<any>(this.baseUrl + "SaveAssessment", assessment);
  }
}
